import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { CCTipoDeDocumento, CCTiposDeDocumentosFormValues } from '../models/CCTiposDeDocumentos';

export default class CCTiposDeDocumentosStore {

    CCTipoDeDocumentoRegistry = new Map<any, CCTipoDeDocumento>();

    selectedCCTipoDeDocumento: CCTipoDeDocumento | undefined = undefined;
    editMode = false;
    loading = false;
    loadingInitial = false;
 

    constructor() {
        makeAutoObservable(this)
    }

    get CCTipoDeDocumentoByCodigo() {
        return Array.from(this.CCTipoDeDocumentoRegistry.values());
    }

    loadCCTiposDeDocumentos = async () => {
        this.loadingInitial = true;
        try {
            const CCTiposDeDocumentos: CCTipoDeDocumento[] = await agent.CCTiposDeDocumentos.list();
            CCTiposDeDocumentos.forEach(CCTipoDeDocumento => {
                this.setCCTipoDeDocumento(CCTipoDeDocumento);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadCCTipoDeDocumento = async (codigoTipoDocumento: string) => {
        let CCTipoDeDocumento = this.getCCTipoDeDocumento(codigoTipoDocumento);
        if (CCTipoDeDocumento) {
            this.selectedCCTipoDeDocumento = CCTipoDeDocumento;
            return CCTipoDeDocumento;
        } else {
            this.loadingInitial = true;
            try {
                CCTipoDeDocumento =  await agent.CCTiposDeDocumentos.details(codigoTipoDocumento);
                this.setCCTipoDeDocumento(CCTipoDeDocumento);
                runInAction(() => {
                    this.selectedCCTipoDeDocumento = CCTipoDeDocumento || this.selectedCCTipoDeDocumento;
                })
                this.setLoadingInitial(false);
                return CCTipoDeDocumento;
            } catch (error) {
                this.setLoadingInitial(false);
                return CCTipoDeDocumento;
            }
        }
    }

    private setCCTipoDeDocumento = (CCTipoDeDocumento: CCTipoDeDocumento) => {
        this.CCTipoDeDocumentoRegistry.set(CCTipoDeDocumento.codigoTipoDocumento, CCTipoDeDocumento);
    }

    private getCCTipoDeDocumento = (codigoTipoDocumento: any) => {
        return this.CCTipoDeDocumentoRegistry.get(codigoTipoDocumento);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createCCTipoDeDocumento = async (CCTipoDeDocumento: CCTiposDeDocumentosFormValues) => {
        try {
            await agent.CCTiposDeDocumentos.create(CCTipoDeDocumento);
            runInAction(() => {
                this.selectedCCTipoDeDocumento = CCTipoDeDocumento;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    updateCCTipoDeDocumento = async (CCTipoDeDocumento: CCTiposDeDocumentosFormValues) => {
        try {
            await agent.CCTiposDeDocumentos.update(CCTipoDeDocumento);
            runInAction(() => {
                if (CCTipoDeDocumento.codigoTipoDocumento) {
                    let updateCCTipoDeDocumento = {...this.getCCTipoDeDocumento(CCTipoDeDocumento.codigoTipoDocumento), ...CCTipoDeDocumento}
                    this.CCTipoDeDocumentoRegistry.set(CCTipoDeDocumento.codigoTipoDocumento, updateCCTipoDeDocumento as CCTipoDeDocumento);
                    this.selectedCCTipoDeDocumento = updateCCTipoDeDocumento as CCTipoDeDocumento
                    this.loading = false;
                }
                   
            } )
        } catch (error) {
        }
    }

    deleteCCTipoDeDocumento = async (codigoTipoDocumento: string) => {
        this.loading = true;
        try {
            await agent.CCTiposDeDocumentos.delete(codigoTipoDocumento);
            runInAction(() => {
                this.CCTipoDeDocumentoRegistry.delete(codigoTipoDocumento);
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }


}